import React from 'react';
import { Activity, CheckCircle, Clock, Euro } from '../../../../shared/assets/AppIcons';
import { MetricGrid } from '../../../../shared/components/patterns';

export default function AutomationStatsGrid({ activeCount, stats }) {
  return <MetricGrid metrics={[
    { id: 'active', label: 'Automazioni Attive', value: activeCount, icon: CheckCircle, tone: 'neutral' },
    { id: 'uses', label: 'Utilizzi Totali', value: stats.totaleUtilizzi, icon: Activity, tone: 'neutral' },
    { id: 'time', label: 'Tempo Risparmiato', value: `${stats.tempoRisparmiatoOre}h ${stats.tempoRisparmiatoMinuti}m`, icon: Clock, tone: 'neutral' },
    { id: 'cost', label: 'Costo Mensile', value: `EUR ${stats.costoTotale.toFixed(2)}`, icon: Euro, tone: 'neutral' },
  ]} />;
}
